import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { SpinnerSize } from './spinning-loader';

export const SPINNER_SIZES: Record<SpinnerSize, number> = {
  xl: 56,
  large: 40,
  medium: 32,
  small: 24,
  xs: 16,
  xxs: 12,
};

export const SPINNER_BORDERS: Record<SpinnerSize, number> = {
  xl: 6,
  large: 6,
  medium: 4,
  small: 2,
  xs: 2,
  xxs: 2,
};

export const SPINNER_MARGIN = 4;

export const CONTENT_LOADER = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${theme.zIndex.high};
`;

export const CONTENT_LOADER_TEXT = css`
  margin-top: ${theme.spacing(1)};
`;

export const SPINNER = css`
  display: inline-block;
  position: relative;
`;

export const SPINNER_RING = css`
  box-sizing: border-box;
  display: block;
  position: absolute;
  border-style: solid;
  border-radius: 50%;
  animation: spin 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  &:nth-of-type(1) {
    animation-delay: -0.45s;
  }

  &:nth-of-type(2) {
    animation-delay: -0.3s;
  }

  &:nth-of-type(3) {
    animation-delay: -0.15s;
  }
`;

export const SKELETON_BASE = css`
  display: block;
  background-color: ${theme.colors.neutral10};
`;

export const SKELETON_CIRCLE = css`
  border-radius: 50%;
`;

export const SKELETON_RECTANGLE = css`
  border-radius: ${theme.borderRadius.small};
`;

export const SKELETON_PULSE = css`
  animation: skeleton-pulse 1s linear alternate infinite;

  @keyframes skeleton-pulse {
    from {
      opacity: 0.3;
    }

    to {
      opacity: 1;
    }
  }
`;

export const SKELETON_SHIMMER = css`
  background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 35%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0) 70%
    )
    ${theme.colors.neutral10};

  background-size: 200% 100%;
  background-position-x: 170%;

  animation: skeleton-shimmer 1s ease-in-out infinite;

  @keyframes skeleton-shimmer {
    to {
      background-position-x: -20%;
    }
  }
`;
